import { Environments } from '@/config';
import { ROCHESTER_PRODUCTION } from './rochester.production';
import { ROCHESTER_STAGING } from './rochester.staging';

export const ROCHESTER = import.meta.env.MODE === Environments.PROD ? ROCHESTER_PRODUCTION : ROCHESTER_STAGING;
